module.exports = __webpack_public_path__ + "images/logicx_small1c895f9de93e67ee49c9e03e6b7a233a.png";